export default class BusinessObjectIndex {

  private obj;
  
  constructor(){
    this.obj = new window.businessObjectIndex();
    return this.obj;
  }

  public generateIndex() {
    this.obj.generateIndex();
  }
  /**
   * 
   * @param {string} name the field which you want to query 
   * @param value the value to match
   * @param comparator the type of match. EQUALS((byte)0),
      GREATER((byte)1),
      GREATEREQUALS((byte)2),
      SMALLER((byte)3),
      SMALLEREQUALS((byte)4),
      RANGE((byte)5),
      UNEQUAL((byte)6);
   */
  public addIndex(name: string, value: any, comparator:0 | 1 | 2| 3| 4 | 5| 6) {
    this.obj.addIndex(name, value, comparator);
  }

  /**
   * 
   * @param {string} name the field to compare
   * @param value the value to match
   * @param comparator the type of match. EQUALS((byte)0),
      GREATER((byte)1),
      GREATEREQUALS((byte)2),
      SMALLER((byte)3),
      SMALLEREQUALS((byte)4),
      RANGE((byte)5),
      UNEQUAL((byte)6);
   * @param fieldType the datatype of the field STRING(0), 
      FLOAT(1), 
      DOUBLE(2), 
      INT8(3), 
      INT16(4), 
      INT32(5), 
      INT64(6), 
      BLOB_HEX(7), 
      BLOB_BASE64(8), 
      GPSPOSITION_FLOAT(9), 
      GPSPOSITION_DOUBLE(10), 
      BOOLEAN(11),
      ENUM(12),
      BITMASK(13),
      KEY(14),
      ANY(99);
   */

  public addIndexFieldType(name: string, value: any, comparator:0 | 1 | 2| 3| 4 | 5| 6, fieldType: number) {
    this.obj.addIndexFieldType(name, value, comparator, fieldType);
  }
  /**
   * 
   * @param {query} subquery an instance of a class 
   * @param {number} operator 0 - AND 1 - OR
   */
  public addSubQuery(subquery: BusinessObjectIndex, operator: number) {
    this.obj.addSubQuery(subquery, operator);
  }

  public addDefaultIndex(name: string, value: any) {
    this.obj.addDefaultIndex(name, value);
  }

  removeIndex(name: string) {
    this.obj.removeIndex(name);
  }

  removeSubquery(sub: BusinessObjectIndex) {
    this.obj.removeSubquery(sub);
  }
}
